import { Avatar, Box, Button, Card, CardActions, CardHeader, CircularProgress, CssBaseline, Grid, IconButton, Modal, Paper, Stack, Typography, colors, useMediaQuery, useTheme } from '@mui/material'
// import React from 'react'
// import { Stack } from 'react-bootstrap'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { getDateTimeForTab3, getGraphDateTime, getGraphTab3DateTime } from '../../utils'
import { WmcContext } from '../../context/WmcContext'
import FilterStrip from '../FilterStrip'
import SingleLineChart from '../charts/SingleLineChart'
import TempMeter from '../charts/TempMeter'
import TwoHeadTable from '../TwoHeadTable'
import WmsTab3Table from './WmsTab3Table'
import { AuthenticationContext } from '../../context/AuthenticationContext'
import AppModal from '../AppModal'

function WmsTab3TabContent({ WM_TYPE, tabTitle,menuItem }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { getWmSENSTab3Data, getWmcDashTab3, WmcSensTab3Data, WmcDashTab3Data, SingleWmDash } = useContext(WmcContext)
    const { palette, breakpoints, shape: { }, spacing } = useTheme()
    const lgs = useMediaQuery(breakpoints.down('xl'))
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')
    const WEB_KEY = "WEBXYZ321"
    const DATA_TYPE = "0"

    const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)
    const [datasets, setDatasets] = useState([])
    const [labels, setLabels] = useState([])
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    // console.log('DASH', WmcDashTab3Data)
    const [TblStartDate, setTblStartDate] = useState(getDateTimeForTab3().LastDay)
    const [TblEndDate, setTblEndDate] = useState(getDateTimeForTab3().Today)

    const PASS_KEY = "WERRRRRRRRRRR"

    function onRefreshGarphData() {
        if (FromDate.length !== 0 && ToDate.length !== 0) {
            console.log("FromTab3MethodGrph", { LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate })
            getWmcDashTab3(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate)
        } else {
            alert('please provide any date')
        }
    }

    function onTblDataRefresh() {
        if (FromDate.length !== 0 && ToDate.length !== 0) {
            console.log("FromTab3MethodTbl", { LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate })
            getWmcDashTab3(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate)
        } else {
            alert('please provide any date')
        }

    }


    const SolarInsolationHeader = [
        'Sn',
        'Date Time',
        'Solar Insolation',
        'Peak Irradiance',
        'Peak IRR.Time'
    ]

    const WindDirectionHeader = [
        'Sn',
        'Date Time',
        'Wind Direction'
    ]

    const TableHead = [
        'Sn',
        'Date Time',
        'Minimum Value',
        'Min DateTime',
        'Maximum Value',
        'Max DateTime',
        'Average Value',
    ]

    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '0.8rem'
        }
    }

    useEffect(() => {
        if (WmcDashTab3Data?.length > 0) {
            if (tabTitle == 'Solar Insolation') {
                setDatasets([
                    {
                        label: tabTitle,
                        data: WmcDashTab3Data?.map(item => item[tabTitle]),
                        fill: false,
                        borderColor: 'green',
                        tension: 0.3,
                        borderWidth: 0.9,

                        pointRadius: 1,
                        pointHoverRadius: 1
                    },
                ])
                setLabels(WmcDashTab3Data?.map(item => item?.Date))
            } else {
                setDatasets([
                    // {
                    //     label: tabTitle,
                    //     data: WmcDashTab3Data?.map(item => item[tabTitle]),
                    //     fill: false,
                    //     borderColor: 'green',
                    //     tension: 0.3,
                    //     borderWidth: 0.9,

                    //     pointRadius: 1,
                    //     pointHoverRadius: 1
                    // },
                    {
                        // hidden: true,
                        label: 'Min',
                        data: WmcDashTab3Data?.map(item => item?.MIN_VALUE),
                        fill: true,
                        borderColor: 'yellow',
                        tension: 0.3,
                        borderWidth: 0.9,

                        pointRadius: 1,
                        pointHoverRadius: 1
                    },
                    {
                        label: 'Max',
                        data: WmcDashTab3Data?.map(item => item?.MAX_VALUE),
                        fill: false,
                        borderColor: 'red',
                        tension: 0.3,
                        borderWidth: 0.9,

                        pointRadius: 1,
                        pointHoverRadius: 1
                    },
                    {
                        label: 'Avg',
                        data: WmcDashTab3Data?.map(item => item?.AVG_VALUE),
                        fill: false,
                        borderColor: 'blue',
                        tension: 0.3,
                        borderWidth: 0.9,

                        pointRadius: 1,
                        pointHoverRadius: 1
                    }
                ])
                setLabels(WmcDashTab3Data?.map(item => item?.Date))

            }
        }
    }, [WmcDashTab3Data])


    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} component={Stack} rowGap={spacing(1)} py={spacing(1)}>
                <Grid container spacing={spacing(1)}>
                    <Grid item md={8} sm={12}>
                        <Stack rowGap={spacing(1)}>
                            <FilterStrip
                                title={tabTitle}
                                ValueOf1={FromDate}
                                ValueOf2={ToDate}
                                onChangeValueOf1={(val) => setFromDate(val.target.value)}
                                onChangeValueOf2={(val) => setToDate(val.target.value)}
                                onFullScreen={handleOpen}
                                onRefreshData={onRefreshGarphData}
                            />
                            {
                                tabTitle == 'Wind Direction' ? <Typography variant='body2' color={'error.main'} textAlign={"center"}>Nothing to show</Typography> :
                                    <>


                                        {
                                            // SensDataLoading
                                            //     ? <Typography variant='h5'>Please Wait............</Typography>
                                            // : 
                                            WmcDashTab3Data?.length > 0
                                                ? <SingleLineChart data={datasets} labels={labels} />
                                                : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
                                        }


                                    </>
                            }

                        </Stack>
                    </Grid>
                    <Grid item md={4} sm={12}>
                        <TempMeter title={tabTitle} data={SingleWmDash} menuItem={menuItem}/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item md={12} sm={12}>
                        <WmsTab3Table
                            radiationName={tabTitle}
                            TableHead={tabTitle == 'Solar Insolation' ? SolarInsolationHeader : tabTitle == 'Wind Direction' ? WindDirectionHeader : TableHead}
                            TableData={WmcDashTab3Data}
                            ValueOf1={FromDate}
                            ValueOf2={ToDate}
                            onChangeValueOF1={(val) => setFromDate(val.target.value)}
                            onChangeValueOF2={(val) => setToDate(val.target.value)}
                            onRefreshData={onTblDataRefresh}
                        />
                    </Grid>
                </Grid>


                {/* Graph FullScreen */}

                <AppModal
                    open={open}
                    handleClose={handleClose}
                >

                    <Typography variant='h5' textAlign={'center'}>{tabTitle}</Typography>

                    {
                        // SensDataLoading ? <CircularProgress /> :
                        WmcDashTab3Data?.length > 0 ? <SingleLineChart data={datasets} labels={labels} /> : <Typography textAlign={'center'} variant='body2' color={'error.main'}>Data Not Found</Typography>
                    }
                </AppModal>



            </Box>


        </>
    )
}

export default WmsTab3TabContent

